module.exports = __webpack_public_path__ + "static/media/function.66401100.svg";